// extracted by mini-css-extract-plugin
export default {"button":"styles_button__BM1ak","text":"styles_text__qr0to"};